import { WATCH_LIMIT } from './limits'

// Obserwowane gościa: tylko w tej przeglądarce (localStorage), [{ id, type, at }], najwyżej WATCH_LIMIT.
const KEY = 'spl:obserwowane'
const OBJECT_ID = /^[0-9a-f]{24}$/i
const listeners = new Set()

export function readGuest () {
    try {
        const raw = JSON.parse(localStorage.getItem(KEY) || '[]')
        if (!Array.isArray(raw)) return []
        const seen = new Set()
        return raw.filter(x => x && OBJECT_ID.test(x.id) && !seen.has(x.id) && seen.add(x.id))
            .map(x => ({ id: x.id, type: typeof x.type === 'string' ? x.type : 'car_ad', at: Number(x.at) || 0 }))
    } catch (err) {
        return []
    }
}

function writeGuest (list) {
    try {
        if (list.length) localStorage.setItem(KEY, JSON.stringify(list))
        else localStorage.removeItem(KEY)
    } catch (err) { /* brak dostępu do localStorage */ }
    listeners.forEach(fn => fn())
}

// Zmiany z tej karty i z innych kart (zdarzenie storage).
export function subscribeGuest (fn) {
    listeners.add(fn)
    const onStorage = (e) => { if (e.key === KEY || e.key === null) fn() }
    window.addEventListener('storage', onStorage)
    return () => { listeners.delete(fn); window.removeEventListener('storage', onStorage) }
}

// true — dodane (albo już było), 'limit' — lista pełna.
export function addGuest ({ id, type, at }) {
    const list = readGuest()
    if (list.some(x => x.id === String(id))) return true
    if (list.length >= WATCH_LIMIT) return 'limit'
    writeGuest([{ id: String(id), type: type || 'car_ad', at: at || Date.now() }, ...list])
    return true
}

// Usuwa i zwraca usunięty wpis (do „Cofnij”).
export function removeGuest (id) {
    const list = readGuest()
    const item = list.find(x => x.id === String(id)) || null
    if (item) writeGuest(list.filter(x => x.id !== item.id))
    return item
}

export function removeGuestMany (ids) {
    const drop = new Set(ids.map(String))
    const list = readGuest()
    if (list.some(x => drop.has(x.id))) writeGuest(list.filter(x => !drop.has(x.id)))
}

export function clearGuest () {
    writeGuest([])
}
